module.exports = __webpack_public_path__ + "img/tex_dt04.b12c24a2.svg";